<template>
  <div class="main-header">
    <div class="main-menu container">
      <el-menu :router="true" :default-active="activeIndex" mode="horizontal" background-color="#fff" text-color="#333">
        <el-row type="flex">
          <el-col :span="4">
            <el-menu-item index="/">
              <img class="logo-text" src="~/assets/logo-text-small.svg">
            </el-menu-item>
          </el-col>
          <el-col :span="20">
            <el-row type="flex" justify="end">
              <el-menu-item index="/features">Features</el-menu-item>
              <el-menu-item index="/pricing">Pricing</el-menu-item>
              <el-menu-item index="/wiki">
                <a href="https://github.com/PTDefender/Welcome" target="_blank">Wiki</a>
              </el-menu-item>
              <el-menu-item v-if="license" index="/account">My Account</el-menu-item>
              <el-menu-item v-else index="/buy">Buy Now</el-menu-item>
            </el-row>
          </el-col>
        </el-row>
      </el-menu>
    </div>
  </div>
</template>

<script>
import license from '@/lib/license'

export default {
  name: 'MainMenu',
  computed: {
    license() {
      return license.current()
    },
    activeIndex() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.main-header {
  z-index: 99999;
  background-color: #fff;

  .main-banner {
    padding: 15px 10px;
    background-color: $--color-primary;
    text-align: center;

    a {
      color: #fff;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }

    span {
      color: #fff;
      font-weight: 400;
      text-decoration: none;
    }
  }

  .main-menu {
    background-color: #fff;
    padding: 8px;

    img.logo-text {
      width: auto;
      height: 52px;
      transform: translate(0, -2px);
    }

    .el-menu {
      border-bottom: none !important;

      .el-menu-item {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 16px;
        border-bottom: none !important;
        background-color: #fff !important;

        &:hover {
          cursor: pointer;
        }

        &.is-active {
          color: $--color-primary;
          cursor: inherit;
        }

        a {
          color: #333;
          display: block;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
